import find from "lodash/find";
import { useRecaptcha3 } from "/composables/useRecaptcha3.js";
import { ref, watch, computed } from "vue";
import { useStore } from "@nuxtjs/composition-api";
import { useLists } from "/composables/useLists";


export default {
  __name: 'index',
  props: {
  variant: {
    type: String,
    required: false,
    validator: function (value) {
      return (
        [
          "create",
          "edit",
          "duplicate",
          "delete",
          "add-item",
          "remove-item",
        ].indexOf(value) !== -1
      );
    },
    default: "create",
  },
  initialName: {
    type: String,
    required: false,
    default: "",
  },
  listId: {
    type: [String, Number],
    required: false,
  },
  onSuccess: {
    type: Function,
    required: false,
    default: function () {},
  },
  sku: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const useNewListForm = ref(false);
const errorMsg = ref("");
const store = useStore();
const {
  lists,
  addItem,
  removeItem,
  getList,
  addList,
  removeList,
  editList,
  duplicateList,
  updateSkuQuantity,
} = useLists();
const { onSubmit } = useRecaptcha3();

const addProductToExistingList = ref(false);

const submitting = ref(false);

const inputTextLabel = computed(() => {
  return props.variant === "remove-item"
    ? store.state.labels.product_name
    : store.state.labels.list_name;
});
const existingLists = ref([]);

const formValues = ref({});
if (props.initialName) {
  formValues.value.name = props.initialName;
}

const submitTitle = computed(() => {
  let title = "";
  switch (props.variant) {
    case "create":
      title = store.state.labels.cta.create_new_list;
      break;

    case "edit":
      title = store.state.labels.cta.update_list_name;
      break;

    case "duplicate":
      title = store.state.labels.cta.duplicate_list_name;
      break;

    case "delete":
      title = store.state.labels.cta.confirm_delete_list;
      break;

    case "add-item":
      title = store.state.labels.cta.add_to_new_list;
      break;

    case "remove-item":
      title = store.state.labels.cta.remove_from_list;
      break;
  }

  return title;
});

const selectListSubmitTitle = computed(() => {
  // initialQuantityInCurrentList ? $store.state.labels.cta.update_quantity : $store.state.labels.cta.add_to_list
  if (formValues.value.target == "new") {
    return store.state.labels.cta.proceed;
  } else if (initialQuantityInCurrentList.value) {
    return store.state.labels.cta.update_quantity;
  } else {
    return store.state.labels.cta.add_to_list;
  }
});

async function handleSubmit(e) {
  let data;
  const recaptchaToken = await onSubmit();
  if (!recaptchaToken) {
    handleError();
  }

  submitting.value = true;

  switch (props.variant) {
    case "create":
      // create new list
      data = await addList(formValues.value.name, recaptchaToken);
      break;

    case "edit":
      // update list name
      data = await editList(
        props.listId,
        formValues.value.name,
        recaptchaToken
      );
      break;

    case "duplicate":
      // duplicate list
      data = await duplicateList(
        props.listId,
        formValues.value.name,
        recaptchaToken
      );
      break;

    case "delete":
      // delete list
      data = await removeList(props.listId, recaptchaToken);
      if (data.status !== "success") {
        window.location.reload();
        return;
      }
      break;

    case "add-item":
      // add to existing list | create new list + add

      if (addProductToExistingList.value) {
        addProductToExistingList.value = false;
        useNewListForm.value = formValues.value.target === "new";
        if (useNewListForm.value) {
          // new list case
          e.preventDefault();
          e.stopPropagation();
          submitting.value = false;
          return;
        } else {
          // not new list case
          if (initialQuantityInCurrentList.value === 0) {
            data = await addItem(
              formValues.value.target,
              props.sku,
              recaptchaToken,
              formValues.value.total
            );
          } else {
            data = await updateSkuQuantity(
              formValues.value.target,
              formValues.value.total,
              props.sku
            );
          }
        }
      } else {
        if (!formValues.value.name) {
          submitting.value = false;
          return;
        }

        data = await addList(formValues.value.name, recaptchaToken);
        if (data.list_id) {
          const recaptchaToken2 = await onSubmit();
          data = await addItem(
            data.list_id,
            props.sku,
            recaptchaToken2,
            formValues.value.total
          );
        }
      }
      break;

    case "remove-item":
      // remove from existing list | create new list + add
      data = await removeItem(props.listId, props.sku, recaptchaToken);
      break;
  }

  // handle server error if needed
  //handleServerError();

  // handle error if needed
  //handleError(err);

  // handle success
  data.status === "success" ? handleSuccess() : handleError();

  submitting.value = false;
}

function handleSuccess() {
  props.onSuccess();
}

function handleError(err) {
  switch (props.variant) {
    case "create":
      // create new list
      break;

    case "edit":
      // update list name
      break;

    case "duplicate":
      // duplicate list
      break;

    case "delete":
      // delete list
      break;

    case "add-item":
      if (err === "already-added") {
        errorMsg.value = store.state.labels.product_already_on_list;
      }
      break;
  }
}

function handleServerError() {
  errorMsg.value = store.state.labels.something_went_wrong;

  setTimeout(() => {
    try {
      errorMsg.value = "";
    } catch (e) {}
  }, 4500);
}

// const isProductInCurrentSelectedList = computed(() => {
//   const currentList = find(lists.value, (o) => o.id == formValues.value.target);
//   if (!currentList?.list.length) {
//     return false;
//   }
//   return find(currentList.list, (o) => o.sku == props.sku);
// });

watch(lists, (value) => {
  const data = [{ id: "new", title: "New list", quantity: 1 }, ...value];
  let arr = [];

  for (let i = 0; i < data.length; i++) {
    arr.push({
      value: data[i].id,
      label: data[i].title,
      quantity: parseInt(
        data[i].id == "new"
          ? 1
          : find(data[i].list, (o) => o.sku == props.sku)?.qty || 0
      ),
    });
  }

  existingLists.value = arr;
});

const initialQuantityInCurrentList = ref(1);

function updateQuantity(qty) {}

function updateList(e) {
  initialQuantityInCurrentList.value = find(existingLists.value, {
    value: e,
  }).quantity;
}

getList();

return { __sfc: true,props, useNewListForm, errorMsg, store, lists, addItem, removeItem, getList, addList, removeList, editList, duplicateList, updateSkuQuantity, onSubmit, addProductToExistingList, submitting, inputTextLabel, existingLists, formValues, submitTitle, selectListSubmitTitle, handleSubmit, handleSuccess, handleError, handleServerError, initialQuantityInCurrentList, updateQuantity, updateList }
}

}